import React from 'react';
import PropTypes from 'prop-types';
import Recoil from 'recoil';
import { NavLink } from 'react-router-dom';
import { routingState } from 'store/atoms';

/**
 * NavigationLink component.
 * Encapsulates the React Router Link.
 * The keyword prop isn't the actual url, it's a key for lookup in the translations table.
 *
 * @param {object} object
 * @param {string} object.keyword
 * @param {string} object.title
 * @param {React.Component[]} object.children
 * @returns {React.Component}
 */
const NavigationLink = ({ keyword, title, children, ...props }) => {
  const routing = Recoil.useRecoilValue(routingState);

  if (routing.routePaths === undefined) {
    throw new Error('Missing Route Paths');
  }

  const to = routing.routePaths[keyword];

  return (
    <NavLink
      to={to}
      {...props}
    >
      {title || children || to}
    </NavLink>
  );
};

NavigationLink.propTypes = {
  keyword: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

NavigationLink.defaultProps = {
  title: null,
  children: null,
  keyword: '/',
};

export default NavigationLink;
